import { render, staticRenderFns } from "./SideBarParent.vue?vue&type=template&id=1c15b458&scoped=true"
import script from "./SideBarParent.vue?vue&type=script&lang=js"
export * from "./SideBarParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c15b458",
  null
  
)

export default component.exports